<div class="labels-picker">
  <ul class="labels-picker__chips" role="list">
    @for (label of assigned(); track label.id) {
      <li
        appBadge
        tone="neutral"
        size="sm"
        class="labels-picker__chip"
        [style.borderColor]="label.color"
        [style.color]="label.color"
      >
        <span class="labels-picker__dot" [style.background]="label.color" aria-hidden="true"></span>
        <span class="labels-picker__chip-name">{{ label.name }}</span>
        <button
          *appIfPermission="'conversations:base:labels:assign'"
          type="button"
          appUiIconButton
          variant="danger"
          size="xs"
          shape="pill"
          [attr.aria-label]="'Remover label ' + label.name"
          [disabled]="busyLabelId() === label.id"
          (click)="remove(label.id)"
        >
          <ng-icon name="heroXMark" size="12" aria-hidden="true" />
        </button>
      </li>
    }
  </ul>

  <div *appIfPermission="'conversations:base:labels:assign'" class="labels-picker__add">
    <button
      type="button"
      appButton
      variant="ghost"
      size="sm"
      [ngpMenuTrigger]="labelsMenu"
      ngpMenuTriggerPlacement="top-start"
    >
      <ng-icon name="heroPlus" size="14" aria-hidden="true" />
      <span>Adicionar label</span>
    </button>
    <ng-template #labelsMenu>
      <div appMenuPanel class="labels-picker__menu" role="dialog">
        @if (available().length > 0) {
          <ul class="labels-picker__list" role="listbox">
            @for (label of available(); track label.id) {
              <li>
                <button
                  type="button"
                  appMenuItem
                  role="option"
                  aria-selected="false"
                  [disabled]="busyLabelId() === label.id"
                  (click)="onAdd(label.id)"
                >
                  <span class="labels-picker__dot" [style.background]="label.color" aria-hidden="true"></span>
                  <span>{{ label.name }}</span>
                </button>
              </li>
            }
          </ul>
        } @else if (!creating()) {
          <p appUiBulkActionMenuEmpty>Nenhuma label disponível.</p>
        }

        <ng-container *appIfPermission="'conversations:base:labels:manage'">
          <div appMenuSeparator></div>
          @if (creating()) {
            <form class="labels-picker__form" (submit)="$event.preventDefault(); submitCreate()">
              <div class="labels-picker__form-row">
                <input
                  appInput
                  type="text"
                  placeholder="Nome da label"
                  maxlength="80"
                  class="h-8 flex-1 text-xs"
                  [value]="draftName()"
                  (input)="setDraftName($any($event.target).value)"
                />
                <button
                  type="submit"
                  appUiIconButton
                  variant="accent"
                  size="xs"
                  [disabled]="!canSubmit()"
                  aria-label="Criar e atribuir"
                  title="Criar e atribuir"
                >
                  <ng-icon name="heroCheck" size="13" aria-hidden="true" />
                </button>
                <button
                  type="button"
                  appUiIconButton
                  variant="ghost"
                  size="xs"
                  aria-label="Cancelar"
                  title="Cancelar"
                  (click)="cancelCreate()"
                >
                  <ng-icon name="heroXMark" size="13" aria-hidden="true" />
                </button>
              </div>
              <app-label-color-picker [value]="draftColor()" (valueChange)="setDraftColor($event)" />
            </form>
          } @else {
            <button type="button" appButton variant="ghost" size="sm" class="w-full justify-start" (click)="startCreate()">
              <ng-icon name="heroPlus" size="13" aria-hidden="true" />
              Criar nova label
            </button>
          }
        </ng-container>
      </div>
    </ng-template>
  </div>
</div>
